import dayjs from "dayjs";
import type { SidebarSortMode, SortSidebarItems } from "./types";

const SIDEBAR_SORT_MODES: SidebarSortMode[] = ["default", "newest", "oldest"];

export const isSidebarSortMode = (value: string): value is SidebarSortMode =>
  (SIDEBAR_SORT_MODES as string[]).includes(value);

export const sortSidebarItems: SortSidebarItems = ({ items, mode }) => {
  if (mode === "default") return items;

  const direction = mode === "newest" ? -1 : 1;
  return [...items].sort(
    (firstItem, secondItem) =>
      direction *
      (dayjs.utc(firstItem.createdAt).valueOf() -
        dayjs.utc(secondItem.createdAt).valueOf()),
  );
};
